<template>
  <div>
    <b-select
      v-if="filterMapItem.component === 'select'"
      v-model="localValue"
      :items="$directory.get(filterMapItem.directory)"
      label="Значення"
      :placeholder="filterMapItem.placeholder || 'оберіть зі списку'"
      hide-details
      :error-messages="getErrorMessages(v$)"
      :loading="$loading.isLoading(filterMapItem.directory)"
      @focus="$directory.fill(filterMapItem.directory)"
      @blur="v$.$touch()"></b-select>
    <b-autocomplete
      v-if="filterMapItem.component === 'autocomplete'"
      v-model="localValue"
      :items="$directory.get(filterMapItem.directory)"
      label="Значення"
      :placeholder="filterMapItem.placeholder || 'оберіть зі списку'"
      hide-details
      :error-messages="getErrorMessages(v$)"
      :loading="$loading.isLoading(filterMapItem.directory)"
      @focus="$directory.fill(filterMapItem.directory)"
      @blur="v$.$touch()"></b-autocomplete>
    <b-select
      v-if="filterMapItem.component === 'select-multiple'"
      v-model="localValue"
      multiple
      chips
      clearable
      :items="$directory.get(filterMapItem.directory)"
      label="Значення"
      :placeholder="filterMapItem.placeholder || 'оберіть зі списку'"
      hide-details
      :error-messages="getErrorMessages(v$)"
      :loading="$loading.isLoading(filterMapItem.directory)"
      @focus="$directory.fill(filterMapItem.directory)"
      @blur="v$.$touch()"></b-select>
    <b-autocomplete
      v-if="filterMapItem.component === 'autocomplete-multiple'"
      v-model="localValue"
      multiple
      chips
      clearable
      :items="$directory.get(filterMapItem.directory)"
      label="Значення"
      :placeholder="filterMapItem.placeholder || 'оберіть зі списку'"
      hide-details
      :error-messages="getErrorMessages(v$)"
      :loading="$loading.isLoading(filterMapItem.directory)"
      @focus="$directory.fill(filterMapItem.directory)"
      @blur="v$.$touch()"></b-autocomplete>
    <b-input
      v-if="filterMapItem.component === 'input'"
      v-model="localValue"
      :placeholder="filterMapItem.placeholder || 'введіть текст'"
      label="Значення"
      hide-details
      :mask="filterMapItem.mask"
      :error-messages="getErrorMessages(v$)"
      @blur="v$.$touch()"></b-input>
    <v-checkbox
      v-if="filterMapItem.component === 'checkbox'"
      v-model="localValue"
      label="Значення"
      true-value="true"
      false-value="false"
      hide-details></v-checkbox>

    <b-input-date
      v-if="
        ['input-date', 'input-date-range'].includes(filterMapItem.component)
      "
      v-model="localValue"
      :range="filterMapItem.component === 'input-date-range'"
      label="Значення"
      :error-messages="getErrorMessages(v$)"
      @blur="v$.$touch()"></b-input-date>
  </div>
</template>

<script lang="ts">
import { FilterMapItem } from './types'
import { computed, PropType, watch } from 'vue'
import { getErrorMessages } from 'best-modules/utils'
import { Validation } from '@vuelidate/core'
import { BInputDate } from 'best-modules/components'
import { fillDirectory } from '@/directory'

export default {
  name: 'FilterInput',
  components: { BInputDate },
  emits: ['update:model-value'],
  props: {
    modelValue: {
      type: [String, Number, Array],
    },
    filterMapItem: {
      type: Object as PropType<FilterMapItem>,
    },
    v$: {
      type: Object as PropType<Validation>,
    },
  },
  methods: { getErrorMessages },
  setup(props, { emit }) {
    const localValue = computed({
      get() {
        return props.modelValue
      },
      set(value) {
        emit('update:model-value', value)
      },
    })

    watch(
      () => props.filterMapItem.directory,
      () => {
        if (props.filterMapItem.directory) {
          fillDirectory(props.filterMapItem.directory)
        }
      }
    )
    watch(
      () => props.filterMapItem.component,
      () => {
        if (props.filterMapItem.component === 'checkbox') {
          emit('update:model-value', 'false')
        }
      },
      { immediate: true }
    )

    return {
      localValue,
    }
  },
}
</script>

<style scoped lang="scss"></style>
